module.exports = __webpack_public_path__ + "static/new-role-46b7acf28724e91ea79e625a8c7e9063.png";